<div class="s1-status-header fender" [style.background-image]="'url(' + randomBackgroundImage + ')'">
  <div class="s1-status-header-content">
    <div style="max-width: 2160px; margin: 0 auto; width: 100%">
      <div style="position: relative; color: white">
        <fui-heading [text]="'home.header.hey_name' | translate: { name: userService.user?.firstName }" color="white" [level]="2" fontSize="f9"></fui-heading>
        <fui-heading [text]="'home.header.welcome_to_myfender' | translate" color="white" [level]="2" fontSize="f9"></fui-heading>
        <div class="t-16 m-b-20" [innerHTML]="'home.header.register_learn_message' | translate"></div>

        @if (productService.studioOneStatus && !userService.needsToLinkFenderAccount) {
          <div class="d-flex">
            @if (productService.studioOneStatus?.color) {
              <fa-icon
                [icon]="productService.studioOneStatus?.color == 'red' || productService.studioOneStatus?.color == 'orange' ? 'exclamation-triangle' : 'circle-check'"
                [style.color]="productService.studioOneStatus?.color"
              ></fa-icon>
            }
            &nbsp;
            <span [innerHTML]="productService.studioOneStatus?.message"></span>
          </div>
          @if (productService.studioOneStatus?.status == "can_redeem_fsp8") {
            <div class="m-t-30">
              <button class="btn btn-primary" (click)="showFspRedeem()">{{ "general.redeem" | translate }}</button>
              <button class="btn btn-blank c-white" (click)="appService.goToCheckout('/onboarding')">{{ "sphere.welcome.subscribe_to_sphere" | translate }}</button>
            </div>
          }
          @if (productService.studioOneStatus?.status == "registered_old_version" || productService.studioOneStatus?.status == "not_registered") {
            <div class="m-t-30">
              <a class="btn btn-primary" (click)="appService.goToCheckout('/onboarding?subscribeOnly=true')">{{ "home.header.subscribe_studio_one_pro_plus" | translate }}</a>
              &nbsp;&nbsp;
              <a class="btn btn-blank c-white" (click)="appService.goToCheckout('/onboarding')">
                {{ productService.studioOneStatus?.status == "not_registered" ? ("home.header.get_studio_one_pro_7" | translate) : ("home.header.upgrade_to_studio_one_pro_7" | translate) }}
              </a>
            </div>
          }
          @if (productService.studioOneStatus?.status == "no_extended_support") {
            <div class="m-t-30">
              <a class="btn btn-primary" (click)="appService.goToCheckout('/onboarding?subscribeOnly=true')">{{ "home.header.subscribe_studio_one_pro_plus" | translate }}</a>
              &nbsp;&nbsp;
              <a class="btn btn-blank c-white" (click)="appService.goToCheckout('/onboarding')">{{ "home.header.get_access_updates" | translate }}</a>
            </div>
          }
          @if (productService.studioOneStatus?.status == "registered_perpetual" || productService.studioOneStatus?.status == "registered_subscription") {
            <div class="m-t-30">
              <a class="btn btn-primary" [routerLink]="['/products/detail/', env.product_ids.fsp8pro]">{{ "home.header.download_installers_content" | translate }}</a>
            </div>
          }
          @if (productService.studioOneStatus?.status == "register_product_cta") {
            <div class="m-t-30">
              <button class="btn btn-primary" (click)="registerProduct()">{{ "newdash.register_product" | translate }}</button>
              @if (showStudioProDemoCta) {
                &nbsp;&nbsp;
                <a class="btn btn-blank" [routerLink]="['/studioprodemo']">🎁 {{ "profile.demo.try_free_demo_cta" | translate }} 🎁</a>
              }
            </div>
          }
        }
        @if (userService.needsToLinkFenderAccount) {
          <div class="d-flex">
            <fa-icon [icon]="'exclamation-triangle'" [style.color]="'red'"></fa-icon>
            &nbsp;
            <span>{{ "link_accounts.you_need_to" | translate }}</span>
          </div>
          <div class="m-t-30">
            <button class="btn btn-primary" (click)="linkFenderAccount()">{{ "link_accounts.link_btn" | translate }}</button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
@if (shouldShowMemDayPromoBanner) {
  <div class="promo-banner">
    <div class="desktop">
      <a [routerLink]="['/onboarding']">
        <img src="./assets/images/fsp-banner-lg.jpg" alt="Mem Day Promo Banner" />
      </a>
    </div>
    <div class="mobile">
      <a [routerLink]="['/onboarding']">
        <img src="./assets/images/fsp-banner-mobile.webp" alt="Mem Day Promo Banner" />
      </a>
    </div>
  </div>
}
